<template>
  <div class="bankAddPage">
    <!-- header start -->
    <van-nav-bar
      title="新增收款账号"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group>
      <van-field input-align="right" label="开户银行" v-model.trim="input.Bank" placeholder="请输入开户银行" />
      <van-field
        input-align="right"
        label="开户城市"
        v-model="areaListInput"
        placeholder="请选择开户城市"
        is-link
        readonly
        @click="showArea"
      />
      <van-field
        input-align="right"
        label="开户支行"
        v-model.trim="input.SubBankName"
        placeholder="请输入开户支行"
      />
    </van-cell-group>

    <van-cell-group>
      <van-field
        label-width="110"
        label="开户银行卡号："
        v-model.trim="input.Account"
        placeholder="仅限储蓄卡号"
      />
      <van-field label-width="110" label="开户人姓名：" v-model.trim="input.Name" placeholder="请输入开户人姓名" />
    </van-cell-group>
    <section class="btn-area">
      <van-button @click="onSubmit" round block color="orange" size="large">保存</van-button>
    </section>

    <!-- 选择省 / 市 / 区 popup start -->
    <van-popup v-model="arealistShow" :lazy-render="false" position="bottom">
      <!-- <van-area
        :area-list="areaList"
        :columns-num="3"
        value="110101"
        @confirm="onConfirm"
        @cancel="arealistShow = false"
      />-->
      <van-picker
        ref="area"
        show-toolbar
        :columns="columns"
        @cancel="arealistShow = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- 选择省 / 市 / 区 popup end -->
  </div>
</template>

<script>
import AreaList from "@/assets/js/area";
import { Toast } from "vant";
export default {
  data() {
    return {
      arealistShow: false,
      areaList: AreaList,
      areaListInput: "",
      columns: [],
      input: {
        Bank: "",
        SubBankName: "",
        Account: "",
        Name: "",
        BankAreaIds: ""
      }
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetAreasListVue"
        })
        .then(
          res => {
            //console.log(res);
            that.columns = res;
          },
          error => {}
        );
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onConfirm(picker, indexs) {
      console.log(this.$refs.area.getIndexes());
      console.log(indexs);
      var province = this.columns[indexs[0]];
      var city = this.columns[indexs[0]].children[indexs[1]];
      // console.log(province.text + "-" + city.text);
      // console.log(province.id + "-" + city.id);
      this.input.BankAreaIds = "~3716~" + province.id + "~" + city.id + "~";
      this.areaListInput = province.text + city.text;
      this.arealistShow = false;

    },
    /*选择省 / 市 / 区*/
    onAreaListChange(picker) {
      var areaValue = picker.getValues();
      console.log(areaValue);
      this.areaListInput = areaValue[0].name + " / " + areaValue[1].name;
    },
    onSubmit() {
      var that = this;
      var params = null;
      if (that.input.Bank == "") {
        Toast("开户银行不能为空！");
        return false;
      }
      if (that.input.BankAreaIds == "") {
        Toast("请选择开户城市！");
        return false;
      }
      if (that.input.Account == "") {
        Toast("银行账号不能为空！");
        return false;
      }
      if (that.input.Name == "") {
        Toast("开户姓名不能为空！");
        return false;
      }
      params = that.input;
      Object.assign(params, {
        type: "AddReceipts"
      });
      that.$store.dispatch(params).then(res => {
        Toast(res.Message);
        if (res.IsSuccess) {
          that.$router.go(-1);
        } else {
        }
      });
    },
    findAreaIndex(dataList, id) {
      var index = 0;
      var isFind = false;
      for (var i = 0; i < dataList.length; i++) {
        if (id == dataList[i].id) {
          isFind = true;
          index = i;
          console.log(index);
          break;
        }
        if (!isFind) {
          if (dataList[i].children != null) {
            this.findAreaIndex(dataList[i].children, id);
          }
        }
      }
      return index;
    },
    showArea() {
      this.arealistShow = true;
      //this.$refs.area.setIndexes([18, 3]);
    }
  },
  created() {}
};
</script>

<style scoped>
</style>
